import { To } from 'react-router-dom';

const mergeSearchParams = (...searchs: (string | URLSearchParams | undefined)[]) => {
  return searchs
    .reduce<URLSearchParams>((acc, search) => {
      const searchParams = new URLSearchParams(search);
      searchParams.forEach((value, key) => {
        acc.set(key, value);
      });

      return acc;
    }, new URLSearchParams())
    .toString();
};

export const resolveToWithSearch = (to: To, search?: string): To => {
  if (typeof to === 'string') {
    return {
      pathname: to,
      search,
    };
  } else if (typeof to === 'object' && typeof to.pathname === 'string') {
    return {
      ...to,
      pathname: to.pathname,
      search: mergeSearchParams(search, to.search),
    };
  }

  return to;
};

export default resolveToWithSearch;
